import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { BPProfilesOEMDataService } from './bp-profiles-oem-data.service';
import { BPProfilesOEMService } from './bp-profiles-oem.service';

@Component({
  selector: 'bp-profiles-oem',
  template: `
    <ui-view></ui-view>
  `,
  styleUrls: ['./bp-profiles-oem.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BPProfilesOEMComponent implements OnDestroy {
  constructor(
    private bpProfilesOEMDataService:BPProfilesOEMDataService,
    private bpProfilesOEMService:BPProfilesOEMService
  ) {
    /**/
  }

  public ngOnDestroy():void {
    this.bpProfilesOEMDataService.clear();
    this.bpProfilesOEMService.clear();
  }
}